import {
  Button,
  ButtonProps,
  InputNumber,
  notification,
  Popconfirm,
} from 'antd';
import React, { useState } from 'react';
import { SplitCellsOutlined } from '@ant-design/icons';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';
import { useQuery } from 'react-query';
import { splitAsset } from 'services/proposal';

type SplitAssetButtonProps = Omit<ButtonProps, 'children'> & {
  assetid: number;
  ctrid: number;
  comcode: string;
  qty: number;
  disabled?: boolean;
  reftechProp?: () => void;
};
const SplitAssetButton = ({
  assetid,
  ctrid,
  comcode,
  qty,
  disabled,
  reftechProp,
  ...otherprops
}: SplitAssetButtonProps) => {
  const { isHidden, label, style } = useComponentConfiguration(comcode);

  const [searchs, setsearchs] = useState(false);
  const [nb, setnb] = useState(disabled ? qty : 0);

  const { isLoading } = useQuery(
    ['splitAsset', assetid],
    () =>
      splitAsset({ assetid, ctrid, qty: nb })
        .then((res) => {
          if (res.code === '200') {
            notification.success({ message: res.message });
            if (reftechProp) reftechProp();
          } else notification.error({ message: res.message });
          setsearchs(false);
          setnb(0);
        })
        .catch(() => {
          setsearchs(false);
          setnb(0);
        }),
    { enabled: searchs }
  );

  if (isHidden) {
    return null;
  }

  const props = {
    ...otherprops,
    children: label,
    style,
  };

  return (
    <Popconfirm
      title={
        <>
          set number of assets to split:{' '}
          <InputNumber
            style={{ width: '50px' }}
            value={nb}
            disabled={disabled}
            onChange={(val) => setnb(val!)}
          />
        </>
      }
      onConfirm={() => {
        if (nb !== 0 && nb <= qty) setsearchs(true);
        else if (nb !== 0 && qty === 1) setsearchs(true);
        else
          notification.error({
            message: 'please insert a valid number of assets to split!',
          });
      }}
      icon={null}
      onCancel={() => setnb(0)}
    >
      <Button
        {...props}
        type="ghost"
        icon={<SplitCellsOutlined style={{ color: '#52c41a' }} />}
        loading={isLoading}
      />
    </Popconfirm>
  );
};

export default SplitAssetButton;
